// extracted by mini-css-extract-plugin
export default {"Appheader":"header_Appheader__o+i3Q","h1":"header_h1__Qgwze","inputcontainer":"header_inputcontainer__knY5f"};